import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';

import AutoUserInput from './AutoUserInput';
import DatePicker from 'react-datepicker';
import ConfirmationModal from './ConfirmationModal';

import * as logEntryActions from '../actions/logEntryActionCreators';
import timesheetActions from '../actions/timesheetActionCreators';

class LogOverviewHeader extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showTimesheetStatusDialog: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleApproveTimesheet = () => {
        if (this._timesheetFilled()) {
            this._approveTimesheet();
        } else {
            let modal = <ConfirmationModal
                            returnKeymaster={this.props.returnKeymaster}
                            hoursLogged={this.props.hoursLogged}
                            minutesLogged={this.props.minutesLogged}
                            quota={this.props.user.weeklyQuota}
                            handleClose={this.closeModal}
                            handleConfirm={this._approveTimesheet}
                            status="approved"
                            />;
            this.setState({
                modal: modal,
                showModal: true
            });
        }
    }

    handleCalendarClick = () => {
        this.setState({
            selectDate: true
        }, () => {
            if (this.datePicker)
                this.datePicker.handleFocus();
            else
                setTimeout(this.datePicker.handleFocus, 100);
        });

        setTimeout(() => {
            moment.updateLocale('en', {
                week: { doy: 4, dow: 1 }
            });
        }, 150);
    }

    handleDateChange = (date) => {
        this.props.handleDateChange(date);
        setTimeout(() => {
            this.setState({
                selectDate: false
            });
        }, 350);
    }

    handleSubmitTimesheet = () => {
        if (this._timesheetFilled()) {
            this._submitTimesheet();
        } else {
            let modal = <ConfirmationModal
                            returnKeymaster={this.props.returnKeymaster}
                            hoursLogged={this.props.hoursLogged}
                            minutesLogged={this.props.minutesLogged}
                            quota={this.props.user.weeklyQuota}
                            handleClose={this.closeModal}
                            handleConfirm={this._submitTimesheet}
                            status="submitted"
                            />;
            this.setState({
                modal: modal,
                showModal: true
            });
        }
    }

    handleUnlockTimesheet = () => {
        this.props.dispatch(timesheetActions.pmoUnlock(this.props.timesheet));
        setTimeout(this._refreshView, 250);
        this.closeUnlockingModal();
    }

    handleUnlockTimesheetModal = () => {
        this.setState({
            showUnlockingModal: true
        });
    }

    // OTHER METHODS

    _approveTimesheet = () => {
        let logEntries = this.props.logEntries;
        this.props.dispatch(timesheetActions.editStatus(this.props.timesheet, "APPROVED"));
        for(let i = 0; i < logEntries.length; i++) {
            this.props.dispatch(logEntryActions.pmoEditStatus(logEntries[i].id, "ACCEPTED"));
        }
        setTimeout(this._refreshView, 250);
    }

    _refreshView = () => {
        this.props.dispatch(logEntryActions.loadOnWeekForUser(this.props.startDay, this.props.user.id));
    }

    _submitTimesheet = () => {
        this.props.dispatch(timesheetActions.editStatus(this.props.timesheet, "SUBMITTED"));
        setTimeout(this._refreshView, 250);
    }

    _timesheetFilled = () => {
        if (!this.props.user) return false;

        if (!this.props.user.weeklyQuota) return true;

        if (this.props.weeklyQuota === this.props.hoursLogged && this.props.minutesLogged === 0) {
            return true;
        }

        return false;
    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    }

    closeUnlockingModal = () => {
        this.setState({
            showUnlockingModal: false
        });
    }

    // RENDER METHOD

    render = () => {

        let hoursSpent = this.props.hoursLogged;
        let minutesSpent = this.props.minutesLogged;
        let overtimeSpent = this.props.overtimeHoursLogged;
        let overtimeMinutesSpent = this.props.overtimeMinutesLogged;
        let regularHoursSpent = this.props.regularHoursLogged;

        let formattedStartDate = this.props.startDay ? this.props.startDay.format("D.M.") : "";
        let formattedEndDate = this.props.endDay ? this.props.endDay.format("D.M.") : "";

        let weekClass = moment().format("ww-YYYY") === this.props.date.format("ww-YYYY") ? "label-day today" : "label-day";
        let formatedWeek = this.props.startDay ? "(Week " + this.props.startDay.isoWeek() + ")" : "";

        let unlockingModal = (
            <Modal show={true} title={"Confirm timesheet unlocking"} onRequestHide={this.closeUnlockingModal}>
                <div className="modal-body">
                    Are you sure you want to unlock this timesheet? This will set its status to entry
                    as well as setting any submitted log entries into draft status?
                </div>
                <div className="modal-footer">
                    <Button onClick={this.handleUnlockTimesheet}>Yes</Button>
                    <Button onClick={this.closeUnlockingModal}>No</Button>
                </div>
            </Modal>
        );

        return (
            <div className="text-center">
                { this.state.showModal ? this.state.modal : null }
                { this.state.showUnlockingModal ? unlockingModal : null }

                <div className="week-header">
                    <div className="panel-log-date">
                        <div className="row">
                            <div className="col-lg-12">
                                <i onClick={this.props.decrementWeek} className="md-chevron-left md-lg"></i>
                                <h4>
                                    <span className={weekClass}>
                                        <span>
                                            {
                                                this.state.selectDate ?
                                                <span className="no-show" style={{ display: "inline-block" }}><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;
                                                    <DatePicker
                                                        className="hideInput"
                                                        ref={ref => this.datePicker = ref}
                                                        dateFormat="YYYY-MM-DD"
                                                        selected={this.props.startDay}
                                                        onChange={this.handleDateChange}
                                                        />
                                                </span>
                                                :
                                                <span><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;</span>
                                            }
                                            {formattedStartDate} - {formattedEndDate} {formatedWeek}
                                        </span>
                                    </span>
                                </h4>
                                <i onClick={this.props.incrementWeek} className="md-chevron-right md-lg"></i>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-2 col-lg-offset-5">
                            Select user:
                                <AutoUserInput
                                    keepAfterClick={true}
                                    users={this.props.users}
                                    forceInitialPopup={false}
                                    />
                        </div>
                    </div>

                    {
                        this.props.user
                        ? <span className="logged-hours-show">Currently logged: {hoursSpent}h {minutesSpent > 0 ? minutesSpent + "min" : null} {overtimeSpent || overtimeMinutesSpent ? " + " + overtimeSpent + " h "  + (overtimeMinutesSpent > 0 ? overtimeMinutesSpent + " min" : "") + " overtime" : null}</span>
                        : null
                    }

                    <div className="submit-week">
                        <span className="logged-hours-show">
                            { this.props.user && this.props.timesheet && this.props.timesheet.status === "SUBMITTED"  ? <h4>Timesheet: Submitted</h4> : null }
                            { this.props.user && this.props.timesheet && this.props.timesheet.status === "APPROVED" ? <h4>Timesheet: Approved</h4> : null }
                            { this.props.user && this.props.timesheet && this.props.timesheet.status === "FIXING" ? <h4>Timesheet: Fixing</h4> : null }
                            { this.props.user && this.props.timesheet && this.props.timesheet.status === "ENTRY" ? <h4>Timesheet: Entry</h4> : null }
                            { this.props.user && this.props.timesheet && (this.props.timesheet.status === "ENTRY" || this.props.timesheet.status === "FIXING")
                                ? <span>&nbsp;&nbsp;<i title="Mark timesheet as Submitted" onClick={this.handleSubmitTimesheet} className="md-person" style={{"cursor" : "pointer"}}/></span>
                                : null }
                            { this.props.user && this.props.timesheet && (this.props.timesheet.status === "SUBMITTED" || this.props.timesheet.status === "FIXING")
                                ? <span>&nbsp;&nbsp;<i title="Unlock timehseet" onClick={this.handleUnlockTimesheetModal} className="md-lock-open" style={{"cursor" : "pointer"}}/></span>
                                : null}
                            { this.props.user && this.props.timesheet && this.props.timesheet.status !== "APPROVED"
                                ? <span>&nbsp;&nbsp;<i title="Mark timesheet as Approved" onClick={this.handleApproveTimesheet} className="md-done" style={{"cursor" : "pointer"}}/></span>
                                : null }
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

LogOverviewHeader.propTypes = {
    date: PropTypes.object,
    decrementWeek: PropTypes.func,
    dispatch: PropTypes.func,
    endDay: PropTypes.object,
    handleDateChange: PropTypes.func,
    hoursLogged: PropTypes.number,
    incrementWeek: PropTypes.func,
    minutesLogged: PropTypes.number,
    overtimeHoursLogged: PropTypes.number,
    overtimeMinutesLogged: PropTypes.number,
    regularHoursLogged: PropTypes.number,
    returnKeymaster: PropTypes.func,
    startDay: PropTypes.object,
    timesheet: PropTypes.object,
    user: PropTypes.object,
    users: PropTypes.array,
    weeklyQuota: PropTypes.number
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogOverviewHeader);



/** WEBPACK FOOTER **
 ** ./src/app/components/LogOverviewHeaderForEditLogs.js
 **/